import { action } from 'easy-peasy';
import { IActionSetOverviewFilters } from '../types';

const setOverviewFilters: IActionSetOverviewFilters = action((state, payload) => {
  state.overviewFilters = payload;
});

export default setOverviewFilters;
